import React, { useState, useContext } from 'react';
import useStyles from '../theme/style';
import UserContext from '../api/UserContext';
import clsx from 'clsx';
import {
  Link,
  AppBar,
  CssBaseline,
  IconButton,
  InputBase,
  Toolbar,
  Typography,
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemText,
  Avatar,
} from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { signOutUser } from '../api/firebase';

const Header = () => {
  const classes = useStyles();
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const user = useContext(UserContext);
  console.log(user);
  const doLogout = (event) => {
    event.preventDefault();
    signOutUser();
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const anchor = 'left';

  const list = (anchor) => (
    <>
      <div style={{ padding: 16, transition: '0.3s' }}>
        <Avatar>H</Avatar>
        <div>
          <Typography variant={'h6'} noWrap>
            {user.displayName}
          </Typography>
        </div>
        <Typography color={'textSecondary'} noWrap gutterBottom>
          {user.email}
        </Typography>
      </div>
      <Divider />
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === 'top' || anchor === 'bottom',
        })}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          {['Categorie', 'Preferiti', 'Notizie', 'Aiuto'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem button key="Logout">
            <Link
              href="#"
              onClick={(event) => {
                doLogout(event);
              }}
            >
              <ListItemText primary="Logout" />
            </Link>
          </ListItem>
        </List>
      </div>
    </>
  );

  return (
    <>
      <CssBaseline />
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(anchor, true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Material-UI
          </Typography>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor={anchor}
        open={state[anchor]}
        onClose={toggleDrawer(anchor, false)}
      >
        {list(anchor)}
      </Drawer>
    </>
  );
};

export default Header;
